import { render } from "./GED.vue?vue&type=template&id=42aa3748"
import script from "./GED.vue?vue&type=script&lang=ts"
export * from "./GED.vue?vue&type=script&lang=ts"
script.render = render

export default script